import c from "./constant";

export const setLiabilities = (liabilities) => ({
  type: c.SET_LIABILITIES,
  liabilities,
});

export const clearLiabilities = () => ({
  type: c.CLEAR_LIABILITIES,
});
